import { gsapSingleton, scrollToPluginSingleton } from "../gsap";
const gsap = gsapSingleton();
const ScrollToPlugin = scrollToPluginSingleton()
import $ from 'jquery';
import Component from '../models/Component';


export default class ScrollTo extends Component {
    constructor(element, context) {
        super(element, context);
    
        $(document).ready(() => {
            const menuLinks = document.querySelectorAll('a[href^="#"]');

            menuLinks.forEach(link => {
                link.addEventListener('click', function(event) {
                    // Previene il comportamento di default del browser (il salto alla sezione)
                    event.preventDefault();

                    const targetId = this.getAttribute('href');
                    const targetElement = document.querySelector(targetId);

                    if (targetElement) {
                        gsap.to(window, {
                        duration: 1.2, 
                        scrollTo: targetId,
                        ease: 'power2.inOut' 
                        });
                    }
                });
            });
        });
    }
}